import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    template: `<div>This component requires extending</div>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadersComponent implements OnInit {
    @Input() public inverted: boolean = false;
    @Input() public color: string = null;
    @Input() public thickness: number = null;

    constructor() { }

    ngOnInit(): void { }
}
